export default "__VITE_ASSET__15218b68__"